import * as constants from './components/global/constants';
import { push } from 'react-router-redux';

// pushes new path as router action
export const navigationMiddleware = store => next => action => {
  if (action.type === constants.NAVIGATE_TO_PAGE)
    store.dispatch(push(action.data));
  next(action)
};
